module.exports = __webpack_public_path__ + "img/broom.6b46bf0d.svg";